import AppLayout from "@features/app/AppLayout"
import { lazy } from "react"
import { createBrowserRouter } from "react-router"

const HomePage = lazy(() =>
  import("@features/home/pages/home-page.tsx").then((module) => ({
    default: module.HomePage,
  })),
)

const ExamplePage = lazy(() =>
  import("@features/example/pages/example-page.tsx").then((module) => ({
    default: module.ExamplePage,
  })),
)

const AppHomePage = lazy(() =>
  import("@features/app/home/pages/home-page").then((module) => ({
    default: module.AppHomePage,
  })),
)

const PermissionPage = lazy(() =>
  import("@features/app/permission/pages/permission-page").then((module) => ({
    default: module.PermissionPage,
  })),
)

export const router = createBrowserRouter([
  {
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      {
        path: "/example",
        element: <ExamplePage />,
      },
      {
        path: "app",
        element: <AppLayout />,
        children: [
          { path: "home", element: <AppHomePage /> },
          { path: "permission", element: <PermissionPage /> },
        ],
      },
    ],
  },
])
